var map = {
	"./blocks/custom/cards/block.js": 2433,
	"./blocks/custom/header/block.js": 6885,
	"./blocks/custom/highlight/block.js": 67418,
	"./blocks/custom/video/block.js": 61233,
	"./blocks/sky/callToActionCharlie/block.js": 189,
	"./blocks/sky/contentBlog/block.js": 78871,
	"./blocks/sky/contentCard/block.js": 30245,
	"./blocks/sky/contentCardThumbnail/block.js": 16161,
	"./blocks/sky/contentStats/block.js": 71068,
	"./blocks/sky/headerAlfa/block.js": 23717,
	"./blocks/sky/headerBravo/block.js": 42241,
	"./blocks/sky/headerCharlie/block.js": 40223,
	"./blocks/sky/icons/block.js": 83292,
	"./blocks/sky/price/block.js": 65999,
	"./blocks/sky/scrollUpAlfa/block.js": 8544,
	"./blocks/sky/sliderAlfa/block.js": 63089,
	"./blocks/sky/sliderBravo/block.js": 67781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49363;